import React, {useState} from 'react'
import './actionCell.css'
import Popover from '@mui/material/Popover';
import { useDispatch } from 'react-redux';
import { handleOpenModal } from '../../state/modalSlice';
import { useNavigate } from 'react-router-dom';


const ActionCell = ({param, text, payroll, appraisal, to}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const openModal = () => {
        dispatch(handleOpenModal(param.row))
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? `popover-${param?.row?.id || param?.row?._id}` : undefined;
    return (
    <div className='action__cell'>
        <i class='bx bx-dots-vertical-rounded action__cell-icon'
        onClick={handleClick}></i>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            sx={{
                '& .MuiPopover-paper': {
                    boxShadow: '0 0 10px 0px rgba(0, 0, 0, 0.1)',
                    minWidth: 100,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                },
            }}
        >
            {
                appraisal ? (
                    <button onClick={()=>navigate(`/appraisal/${param?.row?._id}`)}
                    className="action__cell-btn">
                        View
                    </button>
                ) : to ? (
                    <button onClick={()=>navigate(to)}
                    className="action__cell-btn">
                        View
                    </button>
                ) : (
                    <button onClick={openModal}
                    className="action__cell-btn">
                        {text ?? 'Edit'}
                    </button>
                )
            }
            {
                payroll && <button onClick={openModal}
                className="action__cell-btn">
                    Deduct
                </button>
            }
            
        </Popover>
    </div>
    )
  }

export default ActionCell